import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LandingView from "@/views/onboarding/LandingView.vue";
import RequestOtpView from "@/views/onboarding/RequestOtpView.vue";
import SubmitOtpView from "@/views/onboarding/SubmitOtpView.vue";
import SubmitUsernameView from "@/views/onboarding/SubmitUsernameView.vue";
import ProfileView from "@/views/profile/ProfileView.vue";
import TermsConditionView from "@/views/profile/TermsConditionView.vue";
import UpgradeView from "@/views/profile/UpgradeView.vue";
import UpgradePackageView from "@/views/profile/UpgradePackageView.vue";
import UpgradePackageConfirmationView from "@/views/profile/UpgradePackageConfirmationView.vue";
import HowToPlayView from "@/views/HowToPlayView.vue";
import GamePlayView from "@/views/gameplay/GamePlayView.vue";
import EndScreenView from "@/views/gameplay/EndScreenView.vue";
import {userAuthenticate} from "@/functions/userAuthenticate";
import leaderboardView from "@/views/profile/leaderboardView.vue"
import bonusRoundView from "@/views/gameplay/bonusRoundView.vue";
import BonusEndScreen from "@/views/gameplay/BonusEndScreen.vue";
import BonusEndScreenLoss from "@/views/gameplay/EndScreenLossView.vue";
import PopUpComponent from "@/views/components/PopUpComponent.vue";
import DoiPageView from "@/views/gameplay/DoiPageView.vue";
import DoiSuccessView from "@/views/gameplay/DoiSuccessView.vue";
import FreeTutorialComponent1 from "@/views/components/FreeTutorialComponent1.vue";
import VipTutorialCompnent from "@/views/components/VipTutorialCompnent.vue";
import ManageSubscriptionView from "@/views/profile/ManageSubscriptionView.vue";
import PrizesView from "@/views/PrizesView.vue";


const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/landing',
        name: 'landing',
        component: LandingView
    },
    {
        path: '/login',
        name: 'login',
        component: RequestOtpView
    },
    {
        path: '/submit-otp',
        name: 'submit-otp',
        component: SubmitOtpView

    },
    {
        path: '/username',
        name: 'username',
        component: SubmitUsernameView

    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfileView
    },
    {
        path: '/terms',
        name: 'terms',
        component: TermsConditionView
    },
    {
        path: '/how-to-play',
        name: 'how-to-play',
        component: HowToPlayView

    },

    {
        path: '/upgrade',
        name: 'upgrade',
        component: UpgradeView

    },

    {
        path: '/upgrade-package',
        name: 'upgrade-package',
        component: UpgradePackageView
    },
    {
        path: '/package-confirmation',
        name: 'package-confirmation',
        component: UpgradePackageConfirmationView
    },
    {
        path: '/game-play',
        name: 'game-play',
        component: GamePlayView
    },
    {
        path: '/end-screen',
        name: 'end-screen',
        component: EndScreenView
    },
    {
        path: '/leaderboard',
        name: 'leaderboard',
        component: leaderboardView
    },
    {
        path: '/bonus-round',
        name: 'bonus-round',
        component: bonusRoundView
    },
    {
        path: '/bonus-end-screen',
        name: 'bonus-end-screen',
        component: BonusEndScreen
    },
    {
        path: '/bonus-end-loss',
        name: 'bonus-end-loss',
        component: BonusEndScreenLoss
    },
    {
        path: '/pop-up',
        name: 'pop-up',
        component: PopUpComponent
    },
    {
        path: '/doi',
        name: 'doi',
        component: DoiPageView
    },
    {
        path: '/doi-success',
        name: 'doi-success',
        component: DoiSuccessView
    },
    {
        path: '/free-tutorial',
        name: 'free-tutorial',
        component: FreeTutorialComponent1
    },
    {
        path: '/paid-tutorial',
        name: 'paid-tutorial',
        component: VipTutorialCompnent

    },
    {
        path: '/manage-subscription',
        name: 'manage-subscription',
        component: ManageSubscriptionView
    },
    {
        path: '/prizes',
        name: 'prizes',
        component: PrizesView
    }


]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    await userAuthenticate(to, from, next);
})

export default router
